import { Component, OnInit, OnChanges, Input } from '@angular/core';
import {MatTableModule} from '@angular/material/table';
import { PARETOCOLUMNS } from 'src/app/common/constants/labels';
import * as c3 from 'c3';
import * as d3 from 'd3';

@Component({
  selector: 'app-pareto-report',
  templateUrl: './pareto-report.component.html',
  styleUrls: ['./pareto-report.component.scss']
})
export class ParetoReportComponent implements OnInit, OnChanges {
  paretoCol = PARETOCOLUMNS;
  pReportData = [];
  @Input() paretoReportData: Array<any> = [];
  defectmodeaggregation = [];
  defectpriorityindex = [];
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.pReportData = this.paretoReportData;
    if (!this.paretoReportData) {
      return;
    } else {
      this.processReportData(this.paretoReportData);
    }
  }
  private processReportData(reportData: any[]) {
    const defectmodeaggregationArray = [];
    reportData.forEach(e => {
      defectmodeaggregationArray.push(e.defectmodeaggregation);
      });
    this.defectmodeaggregation = defectmodeaggregationArray;

    const defectpriorityindexArray = [];
    reportData.forEach(e => {
      defectpriorityindexArray.push(e.defectpriorityindex);
    });
    this.defectpriorityindex = defectpriorityindexArray;
    this.generateBarChart(this.defectmodeaggregation, this.defectpriorityindex);
  }
  private generateBarChart(data1: any[], data2: any[]) {
    const dpiValues: any = [];
    const losstreename: any = [];
    const xaxisname = 'x';
    losstreename[0] = xaxisname;
    data1.forEach(e => {
      losstreename.push(e);
    });
    const dataname = 'Defect Priority Index';
    dpiValues[0] = dataname;
    data2.forEach(e => {
      dpiValues.push(e);
    });
    const processparetochart = c3.generate({
      bindto: '#paretochart',
      size: {
        width: 1080,
        height: 400
      },
      data: {
        x: 'x',
        columns: [losstreename, dpiValues],
        type: 'bar',
        labels: true,
        // names: {data1: 'Defect Priorty Index'},
        axes: {
          data1: 'x'
        }
      },
      axis: {
        // rotated: true,
         x: {
           type: 'category'
         },
        y: {
          labels: 'Process Points'
        }
      }
  });
  }
}
